import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { Button } from 'src/system/ui/button/Button'
import { discordColors } from 'src/system/ui/game-colors/brand'
import { useLinkAccount } from 'src/hooks/use-link-account'
import { UserLinkType } from 'src/graphql/types'

export function LinkDiscordButton() {
  const { t } = useTranslation()
  const { redirect, isLoading, isError } = useLinkAccount(UserLinkType.Discord)
  return (
    <>
      <StyledButton
        color={discordColors.blurple}
        aria-label={t('account:discord:label')}
        processing={isLoading}
        onClick={redirect}
      >
        {t('account:discord:link_button')}
      </StyledButton>
      {isError && t('account:discord:error')}
    </>
  )
}

const StyledButton = styled(Button)`
  color: ${discordColors.white};
`
